import './lionTheory.css';
export default function LionTheoryBrand({ href = '/teachers', label = 'FSMTA exam portal', imageWordmark = false }) {
  if (imageWordmark) return <a className="lt-brand" href={href} aria-label={`Lion Theory — ${label}`} style={{ flexDirection: "column", alignItems: "flex-start", gap: 5, maxWidth: "100%" }}>
    <img src="/lion-theory-wordmark.png" alt="Lion Theory" width="180" height="47" style={{ width: 180, maxWidth: "100%", height: 47, objectFit: "contain" }} />
  </a>;
  return <a className="lt-brand" href={href} aria-label={`Lion Theory — ${label}`}>
    <img src="/lion-theory-logo.png" alt="" width="40" height="40" onError={e => { e.currentTarget.hidden = true; }} />
    <span><strong>Lion Theory</strong><small>{label}</small></span>
  </a>;
}
